import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Grid,
  IconButton
} from "@mui/material";

import "./Screen2.css"

import IndustryJobCounts from "./Screen2Graphs/IndustryJobCounts";
import IndustryJobTrends from "./Screen2Graphs/IndustryJobTrends";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
// import DataSources from "./../Screen1/DataSources"

import {
  fetchAverageData,
  fetchCountData,
  fetchPercentData,
  fetchGrowthData,
} from "../../7screen/redux/screen2/actions";
import ScreenDropdown from "app/components/common/ScreenDropdown";

import {
  changeScreenOrientation,
  updateDataSources
} from "../../7screen/redux/ScreensCommon/actions";

import { logActivity } from "../redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";

class Screen2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focusIndustry: ''
    };
  }

  refreshData() {
    this.props.fetchAverageData(this.props.regionSelected);
    this.props.fetchCountData(this.props.regionSelected, this.props.jobTypeSelectedS2);
    this.props.fetchPercentData(this.props.regionSelected, this.props.jobTypeSelectedS2);
    this.props.fetchGrowthData(this.props.regionSelected);
  }

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.regionSelected !== prevProps.regionSelected) {
      this.refreshData();
    }
    if (prevProps.jobTypeSelectedS2 !== this.props.jobTypeSelectedS2) {
      this.props.fetchCountData(this.props.regionSelected, this.props.jobTypeSelectedS2);
      this.props.fetchPercentData(this.props.regionSelected, this.props.jobTypeSelectedS2);
    }
  }

  handleScreenToggle = () => {
    this.props.changeScreenOrientation();
    logActivity({
      screen : UserActivityConstants.SCREEN2.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action : UserActivityConstants.COMMON_ACTIONS.TOGGLE_SCREEN_ORIENTATION,
      action_target : `${this.props.orientationHorizontal ? "Vertical" : "Horizontal"}`
    });
  };

  setFocusIndustry = (industry) => {
    this.setState({focusIndustry: industry});
  };

  handleDataSourceToggle = () => {
    this.props.updateDataSources()
    logActivity({
      screen : UserActivityConstants.SCREEN2.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action : UserActivityConstants.COMMON_ACTIONS.TOGGLE_DATA_SOURCE,
      action_target : `${this.props.displayDataSources ? "Hide data source" : "Show data source"}`
    })
  }

  render() {

    return (
      <div className="screen-wrapper">
        <header className="screen-header">
          <IconButton
              id="data-sources-icon"
              style={{
                color: "white",
                marginLeft: 20,
                marginRight: -60,
                marginTop: -155,
                position: 'relative', // This is required for z-index to work
                zIndex: 1000,
              }}
              onClick={this.handleDataSourceToggle}
            >
              <LibraryBooksIcon className="swap-icon" />
            </IconButton>
          <div className="title">Industry Overview</div>
        </header>
        <Grid container className="screen-content-wrapper screen-content-wrapper-2">
          <Grid container className="screen-content-grid-2" style={{height: "915px"}}>
          <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div style={{ "backgroundColor": "#005898"}} className="rect-shape">
                <span style={{ "display": "block"}}>Total Jobs</span><b>{this.props.averageData["average_total_jobs"] ? this.props.averageData["average_total_jobs"].toLocaleString("en-US") : "NA"}</b>
                </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div style={{ "backgroundColor": "#6AA4DC"}} className="rect-shape">
                <span style={{ "display": "block"}}>H3 Percent</span><b>{this.props.averageData["average_h3_percent_card"] ? Math.round(this.props.averageData["average_h3_percent_card"] * 100) / 100 : "NA"}%</b>
               </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div style={{ "backgroundColor": "#FFB607"}} className="rect-shape">
                <span style={{ "display": "block"}}>Degree Demand</span><b>{this.props.averageData["average_degree_demand"] ? this.props.averageData["average_degree_demand"].toLocaleString("en-US") : "NA"}</b>
              </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div style={{ "backgroundColor": "#FB6A59"}} className="rect-shape">
                <span style={{ "display": "block"}}>Industrial Diversity</span> <b>{this.props.averageData["average_hachman_index"] ? Math.round(this.props.averageData["average_hachman_index"] * 100) / 100: "NA"}</b>
                </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper" style={{paddingRight: 0}}>
              <div style={{ "backgroundColor": "#DE3E40"}} className="rect-shape">
                <span style={{ "display": "block"}}>Median Earnings</span> <b> {this.props.averageData["average_median_earnings"] ? `$${this.props.averageData["average_median_earnings"].toLocaleString("en-US")}` : "NA"}</b>
              </div>
            </Grid>

          <Grid item md={5.71}>
            {/* {this.props.countData && this.props.countData.jobs && this.props.countData.jobs.length != 0 ? */}
              <IndustryJobCounts
                countData={this.props.countData}
                percentData={this.props.percentData}
                focusIndustry={this.state.focusIndustry}
                setFocusIndustry={this.setFocusIndustry}
              />
              {/* : <div style={{textAlign: "center"}}> No data available </div> } */}
            </Grid>
            <Grid item md={6.29}>
            {/* {this.props.growthData &&  JSON.stringify(this.props.growthData) != '{}' ? */}
              <IndustryJobTrends
                  growthData={this.props.growthData}
                  focusIndustry={this.state.focusIndustry}
                />
                {/* : <div style={{textAlign: "center"}}> No data available </div> } */}
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    averageData: { ...state.Screen2Reducer.averageData },
    countData: { ...state.Screen2Reducer.countData },
    percentData: { ...state.Screen2Reducer.percentData },
    growthData: { ...state.Screen2Reducer.growthData },
    orientationHorizontal: state.ScreensCommonReducer.orientationHorizontal,
    displayDataSources: state.ScreensCommonReducer.displayDataSources,
    regionSelected: state.Screen1Reducer.regionSelected,
    jobTypeSelectedS2:  state.Screen2Reducer.jobTypeSelectedS2
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeScreenOrientation,
      updateDataSources,
      fetchAverageData,
      fetchCountData,
      fetchPercentData,
      fetchGrowthData,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Screen2);
